function s(number) {
    return number == 1 ? '' : 's';
}

function have(number) {
    return number == 1 ? 'has' : 'have';
}
